"use strict";

/**
 * Template für eine abstrakte Methode.
 * Macht nichts, außer eine Exception zu werfen.
 *
 * @public
 * @method
 * @throws {gc.gis.error.GCError}
 */
gc.gis.abstractMethod = function()
{
	throw new gc.gis.error.GCError('Abstract method is not implemented.');
};

